/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const FIRES_LANDCOVER_DASHBOARD_AREA = {
    type: "FeatureCollection",
    features: [
        {
            type: "Feature",
            properties: {
                areaName: "Area 1",
            },
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-122.42614746093749, 36.94220903003596],
                        [-121.71478271484375, 36.94220903003596],
                        [-121.71478271484375, 37.345050859282736],
                        [-122.42614746093749, 37.345050859282736],
                        [-122.42614746093749, 36.94220903003596],
                    ],
                ],
            },
        },
    ],
};

export default FIRES_LANDCOVER_DASHBOARD_AREA;
